import { Component } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

/**
 * Dialog for saving filter settings.
 * It contains an input field for entering a name and a button to save the filter.
 */
@Component({
    selector: 'app-dialog-add-filter',
    templateUrl: './dialog-add-filter.component.html',
    styleUrls: ['./dialog-add-filter.component.scss'],
    standalone: false
})
export class DialogAddFilterComponent {
    name = new UntypedFormControl('', Validators.required);

    constructor(readonly dialogRef: MatDialogRef<DialogAddFilterComponent>) {}

    save(): void {
        if (this.name.invalid) {
            this.name.markAllAsTouched();
            return;
        }

        this.dialogRef.close(this.name.value);
    }
}
